import { api } from "../api";
import { DriverParameter } from "../../../types/types";

const saveDriverParameter = async (
    token: string,
    driverParameter: DriverParameter,
) => {
    const response = await api.post<void>(
        "/driver-parameters",
        driverParameter,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );

    return response;
};

export default saveDriverParameter;
